export const BUG_REPORT_TAB = "BUG_REPORT_TAB";
export const CANISTERS_TAB = "CANISTERS_TAB";
export const COLOR_SEARCH_TAB = "COLOR_SEARCH_TAB";
export const COLOR_TAB = "COLOR_TAB";
export const CUSTOM_TAB = "CUSTOM_TAB";
export const CUSTOMERS_TAB = "CUSTOMERS_TAB";
export const FAVORITES_TAB = "FAVORITES_TAB";
export const GLOBAL_SEARCH_TAB = "GLOBAL_SEARCH_TAB";
export const INITIAL_TAB = "INITIAL_TAB";
export const MAIN_TAB = "MAIN_TAB";
export const MATCHING_TAB = "MATCHING_TAB";
export const MY_ORDERS_TAB = "MY_ORDERS_TAB";
export const ORDERS_HISTORY_TAB = "ORDERS_HISTORY_TAB";
export const SPECTRO_TAB = "SPECTRO_TAB";
export const STATISTICS_TAB = "STATISTICS_TAB";
export const TICKETING_TAB = "TICKETING_TAB";
export const TO_DISPENSE_TAB = "TO_DISPENSE_TAB";

export const AUTO_CORRECTION_SCENE = "AUTO_CORRECTION_SCENE";
export const BASE_SCENE = "BASE_SCENE";
export const BIPP_SCENE = "BIPP_SCENE";
export const COLOR_SCENE = "COLOR_SCENE";
export const CUSTOMER_SCENE = "CUSTOMER_SCENE";
export const DATABASE_SCENE = "DATABASE_SCENE";
export const DETAIL_SCENE = "DETAIL_SCENE";
export const FANDECK_SCENE = "FANDECK_SCENE";
export const DRAFT_FORMULA_SCENE = "DRAFT_FORMULA_SCENE";
export const NOTE_SCENE = "NOTE_SCENE";
export const PACKAGE_SCENE = "PACKAGE_SCENE";
export const PRODUCT_SCENE = "PRODUCT_SCENE";
export const SUMMARY_SCENE = "SUMMARY_SCENE";
export const TABLE_SCENE = "TABLE_SCENE";

export const DEFAULT_TAB_ID = 1;
export const NO_SKIP_TAB_ID = -97;
export const QUICK_TINT_TAB_ID = -98;

export const MODAL_NO_TAB = 0;
export const MODAL_SETTINGS_TAB = -1;
export const PURGE_STATS_SUBMENU = -2;
export const COLORANT_REFILL_HISTORY_SUBMENU = -3;

export const MODAL_DEFAULT_STYLE = "DEFAULT";
export const MODAL_SETTINGS_STYLE = "SETTINGS";
export const MODAL_BLANK_STYLE = "BLANK";

export const ADD_COLORANT_PACKAGES_TO_STOCK_MODAL = "ADD_COLORANT_PACKAGES_TO_STOCK_MODAL";
export const ALTERNATIVE_FORMULAS_MODAL = "ALTERNATIVE_FORMULAS_MODAL";
export const AUTHENTICATION_MODAL = "AUTHENTICATION_MODAL";
export const AUTOTASK_MODAL = "AUTOTASK_MODAL";
export const BARCODE_TEST_MODAL = "BARCODE_TEST_MODAL";
export const BEFORE_DISPENSE_COLORANT_BATCH_MODAL = "BEFORE_DISPENSE_COLORANT_BATCH_MODAL";
export const BUG_REPORT_MODAL = "BUG_REPORT_MODAL";
export const BUILDING_SITE_LIST_MODAL = "BUILDING_SITE_LIST_MODAL";
export const CANISTER_BARCODE_MODAL = "CANISTER_BARCODE_MODAL";
export const CANISTER_LEVELS_MODAL = "CANISTER_LEVELS_MODAL";
export const CHECK_BEFORE_DISPENSING_MODAL = "CHECK_BEFORE_DISPENSING_MODAL";
export const CLEAN_ALL_CHANNELS_MODAL = "CLEAN_ALL_CHANNELS_MODAL";
export const CLEAN_CHANNELS_MODAL = "CLEAN_CHANNELS_MODAL";
export const CLOSEST_COLORS_MODAL = "CLOSEST_COLORS_MODAL";
export const COLORANT_PACKAGES_CONFIRM_ORDER_STOCK_MODAL = "COLORANT_PACKAGES_ORDER_STOCK_MODAL";
export const COLORANT_REFILL_HISTORY_MODAL = "COLORANT_REFILL_HISTORY_MODAL";
export const COLORANT_UFI_CODES_MODAL = "COLORANT_UFI_CODES_MODAL";
export const CONFIRMATION_MODAL = "CONFIRMATION_MODAL";
export const CORRECTION_HISTORY_MODAL = "CORRECTION_HISTORY_MODAL";
export const CREATE_ORDER_MODAL = "CREATE_ORDER_MODAL";
export const CUSTOM_FANDECKS_MODAL = "CUSTOM_FANDECKS_MODAL";
export const CUSTOM_PACKAGE_SETTINGS_MODAL = "CUSTOM_PACKAGE_SETTINGS_MODAL";
export const CUSTOMERS_MODAL = "CUSTOMERS_MODAL";
export const DATABASE_FROM_EXCEL_MODAL = "DATABASE_FROM_EXCEL_MODAL";
export const DATE_PICKER_MODAL = "DATE_PICKER_MODAL";
export const DEBUG_MODAL = "DEBUG_MODAL";
export const DELETE_FAVORITE_FOLDER_MODAL = "DELETE_FAVORITE_FOLDER_MODAL";
export const DISPENSING_QUICK_TINT_MODAL = "DISPENSING_QUICK_TINT_MODAL";
export const EDIT_COLORANT_PACKAGE_IN_STOCK_MODAL = "EDIT_COLORANT_PACKAGE_IN_STOCK_MODAL";
export const EDIT_COLORANTS_MODAL = "EDIT_COLORANTS_MODAL";
export const EDIT_CURRENCY_MODAL = "EDIT_CURRENCY_MODAL";
export const EDIT_CUSTOM_FANDECK_MODAL = "EDIT_CUSTOM_FANDECK_MODAL";
export const EDIT_CUSTOMER_MODAL = "EDIT_CUSTOMER_MODAL";
export const EDIT_FORMULA_RGB_MODAL = "EDIT_FORMULA_RGB_MODAL";
export const EDIT_MARGIN_MODAL = "EDIT_MARGIN_MODAL";
export const EDIT_NOTE_MODAL = "EDIT_NOTE_MODAL";
export const EDIT_PASSWORD_MODAL = "EDIT_PASSWORD_MODAL";
export const EDIT_SERVER_MODAL = "EDIT_SERVER_MODAL";
export const EDIT_STATS_NOTE_MODAL = "EDIT_STATS_NOTE_MODAL";
export const EDIT_USER_MODAL = "EDIT_USER_MODAL";
export const FILE_TRANSFER_TASK_MODAL = "FILE_TRANSFER_TASK_MODAL";
export const FIND_TEXT_MODAL = "FIND_TEXT_MODAL";
export const HELP_MODAL = "HELP_MODAL";
export const HIDE_ITEMS_MODAL = "HIDE_ITEMS_MODAL";
export const HISTORY_FORMULAS_MODAL = "HISTORY_FORMULAS_MODAL";
export const INVALID_BATCH_NUMBERS_MODAL = "INVALID_BATCH_NUMBERS_MODAL";
export const CHANGE_DATABASE_MODAL = "CHANGE_DATABASE_MODAL";
export const CHANGELOG_MODAL = "CHANGELOG_MODAL";
export const CHEAPER_COLORS_MODAL = "CHEAPER_COLORS_MODAL";
export const IMPORT_DATA_MODAL = "IMPORT_DATA_MODAL";
export const IMPORT_PRICE_DATA_MODAL = "IMPORT_PRICE_DATA_MODAL";
export const LOADING_MODAL = "LOADING_MODAL";
export const MACHINE_ERRORS_MODAL = "MACHINE_ERRORS_MODAL";
export const MANUAL_ADDITION_UNIT_MODAL = "MANUAL_ADDITION_UNIT_MODAL";
export const MANUAL_ORDER_STOCK_MODAL = "MANUAL_ORDER_STOCK_MODAL";
export const MASTER_PRODUCTS_MODAL = "MASTER_PRODUCTS_MODAL";
export const MATCHING_COLORANTS_MODAL = "MATCHING_COLORANTS_MODAL";
export const MATCHING_DISPENSE_FORMULA_MODAL = "MATCHING_DISPENSE_FORMULA_MODAL";
export const MATCHING_MEASUREMENT_MODAL = "MATCHING_MEASUREMENT_MODAL";
export const NOTE_MODAL = "NOTE_MODAL";
export const ORDER_NOTIFICATION_MODAL = "ORDER_NOTIFICATION_MODAL";
export const PARTIAL_UPDATE_MODAL = "PARTIAL_UPDATE_MODAL";
export const PRINT_MODAL = "PRINT_MODAL";
export const PRINT_PREVIEW_MODAL = "PRINT_PREVIEW_MODAL";
export const PRINT_PREVIEW_ORDER_MODAL = "PRINT_PREVIEW_ORDER_MODAL";
export const PRINT_TASK_MODAL = "PRINT_TASK_MODAL";
export const PRINT_TASK_PREVIEW_MODAL = "PRINT_TASK_PREVIEW_MODAL";
export const PRODUCT_FILE_PREVIEW_MODAL = "PRODUCT_FILE_PREVIEW_MODAL";
export const PRODUCT_FILES_MODAL = "PRODUCT_FILES_MODAL";
export const PROGRESS_BAR_MODAL = "PROGRESS_BAR_MODAL";
export const PURGE_ALL_MODAL = "PURGE_ALL_MODAL";
export const PURGE_MODAL = "PURGE_MODAL";
export const QUALITY_CONTROL_MODAL = "QUALITY_CONTROL_MODAL";
export const QUICK_TINT_MODAL = "QUICK_TINT_MODAL";
export const RECIRCULATE_ALL_CHANNELS_MODAL = "RECIRCULATE_ALL_CHANNELS_MODAL";
export const RECIRCULATE_CHANNELS_MODAL = "RECIRCULATE_CHANNELS_MODAL";
export const REFILL_CONFIRMATION_MODAL = "REFILL_CONFIRMATION_MODAL";
export const REMOVE_PACKAGE_FROM_STOCK_CONFIRM_MODAL = "REMOVE_PACKAGE_FROM_STOCK_CONFIRM_MODAL";
export const RESTART_MODAL = "RESTART_MODAL";
export const RETINT_MODAL = "RETINT_MODAL";
export const SEARCH_IN_STANDARD_FORMULAS = "SEARCH_IN_STANDARD_FORMULAS";
export const SEARCHING_MODAL = "SEARCHING_MODAL";
export const SET_CANISTER_UFI_CODE_MODAL = "SET_CANISTER_UFI_CODE_MODAL";
export const SHOW_BARCODE_MODAL = "SHOW_BARCODE_MODAL";
export const SMART_PURGE_MODAL = "SMART_PURGE_MODAL";
export const SPECTRO_MANUAL_INPUT_MODAL = "SPECTRO_MANUAL_INPUT_MODAL";
export const SPECTRO_MEASUREMENT_DETAIL_MODAL = "SPECTRO_MEASUREMENT_DETAIL_MODAL";
export const STIR_ALL_CANISTERS_MODAL = "STIR_ALL_CANISTERS_MODAL";
export const STIR_CANISTERS_MODAL = "STIR_CANISTERS_MODAL";
export const STOCK_MODAL = "STOCK_MODAL";
export const TICKETING_MODAL = "TICKETING_MODAL";
export const TRANSLATION_MODAL = "TRANSLATION_MODAL";
export const WEBVIEW_MODAL = "WEBVIEW_MODAL";

export const MENU_SEARCH = "MENU_SEARCH";
export const MENU_SERVICE_ACTIONS = "MENU_SERVICE_ACTIONS";
export const MENU_STATISTICS = "MENU_STATISTICS";
export const MENU_MACHINE_MANAGEMENT = "MENU_MACHINE_MANAGEMENT";
export const MENU_MACHINE_SETTINGS = "MENU_MACHINE_SETTINGS";
export const MENU_SPECTRO_SETTINGS = "MENU_SPECTRO_SETTINGS";
export const MENU_PRINT_SETTINGS = "MENU_PRINT_SETTINGS";
export const MENU_RCC_CONNECTION = "MENU_RCC_CONNECTION";
export const MENU_DATABASE_CONNECTION = "MENU_DATABASE_CONNECTION";
export const MENU_DATABASE_IMPORT = "MENU_DATABASE_IMPORT";
export const MENU_SERVER_CONNECTION = "MENU_SERVER_CONNECTION";
export const MENU_IMPORT_CUSTOM_DATA = "MENU_IMPORT_CUSTOM_DATA";
export const MENU_FILE_TRANSFER = "MENU_FILE_TRANSFER";
export const MENU_SERVER_PLUGINS = "MENU_SERVER_PLUGINS";
export const MENU_LICENSE_DATA = "MENU_LICENSE_DATA";
export const MENU_UPDATE_OPTIONS = "MENU_UPDATE_OPTIONS";
export const MENU_BUG_REPORT = "MENU_BUG_REPORT";
export const MENU_MACHINE_ACTION_HISTORY = "MENU_MACHINE_ACTION_HISTORY";

export const SUBMENU_SINGLE_ACTIONS = "SUBMENU_SINGLE_ACTIONS";
export const SUBMENU_SMART_PURGE_RULES = "SUBMENU_SMART_PURGE_RULES";
export const SUBMENU_AUTOTASKS = "SUBMENU_AUTOTASKS";
export const SUBMENU_COLORANT_CONSUMPTION = "SUBMENU_COLORANT_CONSUMPTION";
export const SUBMENU_MACHINE_INFO = "SUBMENU_MACHINE_INFO";
export const SUBMENU_MACHINE_MANAGEMENT = "SUBMENU_MACHINE_MANAGEMENT";
export const SUBMENU_DISPENSING_SETTINGS = "SUBMENU_DISPENSING_SETTINGS";
export const SUBMENU_CANISTER_SETTINGS = "SUBMENU_CANISTER_SETTINGS";
export const SUBMENU_DRIVER_SETTINGS = "SUBMENU_DRIVER_SETTINGS";
export const SUBMENU_REFILL_SETTINGS = "SUBMENU_REFILL_SETTINGS";
export const SUBMENU_REGISTRATION = "SUBMENU_REGISTRATION";
export const SUBMENU_POS_INFO = "SUBMENU_POS_INFO";
export const SUBMENU_LICENSE_STATUS = "SUBMENU_LICENSE_STATUS";
export const SUBMENU_COLORANT_REFILL_HISTORY = "SUBMENU_COLORANT_REFILL_HISTORY";

export const RCC_MACHINE_DIALOG = "RCC_MACHINE_DIALOG";
export const RCC_SPECTRO_DIALOG = "RCC_SPECTRO_DIALOG";
export const HELPER_DIALOG = "HELPER_DIALOG";
export const MESSAGE_DIALOG = "MESSAGE_DIALOG";

export const MACHINE_DIALOG_INFO = "MACHINE_DIALOG_INFO";
export const MACHINE_DIALOG_WARNING = "MACHINE_DIALOG_WARNING";
export const MACHINE_DIALOG_ERROR = "MACHINE_DIALOG_ERROR";
export const MACHINE_DIALOG_REFILL = "MACHINE_DIALOG_REFILL";
export const MACHINE_DIALOG_PROGRESS = "MACHINE_DIALOG_PROGRESS";
export const SPECTRO_DIALOG_INFO = "SPECTRO_DIALOG_INFO";
export const SPECTRO_DIALOG_WARNING = "SPECTRO_DIALOG_WARNING";
export const SPECTRO_DIALOG_ERROR = "SPECTRO_DIALOG_ERROR";
export const HELPER_DIALOG_INFO = "HELPER_DIALOG_INFO";
export const HELPER_DIALOG_WARNING = "HELPER_DIALOG_WARNING";
export const HELPER_DIALOG_ERROR = "HELPER_DIALOG_ERROR";
export const FILE_TRANSFER_DIALOG_CUSTOMER = "FILE_TRANSFER_DIALOG_CUSTOMER";
export const FILE_TRANSFER_DIALOG_CUSTOM_FORMULA = "FILE_TRANSFER_DIALOG_CUSTOM_FORMULA";
export const FILE_TRANSFER_DIALOG_HISTORY = "FILE_TRANSFER_DIALOG_HISTORY";
export const FILE_TRANSFER_DIALOG_ORDER = "FILE_TRANSFER_DIALOG_ORDER";

export const FLASH_MESSAGE_INFO = "FLASH_MESSAGE_INFO";
export const FLASH_MESSAGE_SUCCESS = "FLASH_MESSAGE_SUCCESS";
export const FLASH_MESSAGE_WARNING = "FLASH_MESSAGE_WARNING";
export const FLASH_MESSAGE_ERROR = "FLASH_MESSAGE_ERROR";

export const SERVER_DIALOG_INFO = "info";
export const SERVER_DIALOG_SUCCESS = "success";
export const SERVER_DIALOG_WARNING = "warning";
export const SERVER_DIALOG_ERROR = "error";

export const PRICE_TYPE_DISCOUNT = 4;
export const PRICE_TYPE_SURCHARGE = 3;
export const PRICE_TYPE_PURCHASE = 1;

export const DELTA_RESULT_EXCELLENT = 0.5;
export const DELTA_RESULT_GOOD = 1.5;
export const DELTA_RESULT_OK = 2.5;
export const DELTA_RESULT_FAIR = 3.5;

export const INTERGAMMA_HOME_TAB = "INTERGAMMA_HOME_TAB";
export const INTERGAMMA_SETTINGS_TAB = "INTERGAMMA_SETTINGS_TAB";
export const INTERGAMMA_ANOTHER_TAB = "INTERGAMMA_ANOTHER_TAB";
export const INTERGAMMA_HISTORY_TAB = "INTERGAMMA_HISTORY_TAB";
export const INTERGAMMA_REGISTRATION_TAB = "INTERGAMMA_REGISTRATION_TAB";

export const INTERGAMMA_RESTART_REDLIKE_MODAL = "INTERGAMMA_RESTART_REDLIKE_MODAL";
export const INTERGAMMA_DELETE_ORDER_MODAL = "INTERGAMMA_DELETE_ORDER_MODAL";
export const INTERGAMMA_REBOOT_PC_MODAL = "INTERGAMMA_REBOOT_PC_MODAL";
export const INTERGAMMA_LOAD_HISTORY_ORDER_MODAL = "INTERGAMMA_LOAD_HISTORY_ORDER_MODAL";
export const INTERGAMMA_ADD_SERVER_MODAL = "INTERGAMMA_ADD_SERVER_MODAL";
export const INTERGAMMA_EDIT_SERVER_MODAL = "INTERGAMMA_EDIT_SERVER_MODAL";
export const INTERGAMMA_SW_VERSIONS_MODAL = "INTERGAMMA_SW_VERSIONS_MODAL";
export const INTERGAMMA_MODULE_MODAL = "INTERGAMMA_MODULE_MODAL";
export const INTERGAMMA_DATABASE_LIST_MODAL = "INTERGAMMA_DATABASE_LIST_MODAL";
export const INTERGAMMA_CONFIRM_CUSTOMER_MODAL = "INTERGAMMA_CONFIRM_CUSTOMER_MODAL";
export const INTERGAMMA_WARNING_CUSTOMER_MODAL = "INTERGAMMA_WARNING_CUSTOMER_MODAL";
export const INTERGAMMA_WARNING_MISSING_DATA_MODAL = "INTERGAMMA_WARNING_MISSING_DATA_MODAL";

export const INTERGAMMA_MACHINE_HOME_TAB = "INTERGAMMA_MACHINE_HOME_TAB";
export const INTERGAMMA_MACHINE_ORDER_TAB = "INTERGAMMA_MACHINE_ORDER_TAB";
export const INTERGAMMA_MACHINE_DETAIL_TAB = "INTERGAMMA_MACHINE_DETAIL_TAB";
export const INTERGAMMA_MACHINE_POS_INFO_TAB = "INTERGAMMA_MACHINE_POS_INFO_TAB";
export const INTERGAMMA_MACHINE_CONFIGURATION_TAB = "INTERGAMMA_MACHINE_CONFIGURATION_TAB";

export const INTERGAMMA_MACHINE_FILL_CANISTER_HISTORY_MODAL = "INTERGAMMA_MACHINE_FILL_CANISTER_HISTORY_MODAL";
export const INTERGAMMA_NOTE_MODAL = "INTERGAMMA_NOTE_MODAL";
export const INTERGAMMA_MACHINE_RESTART_REDLIKE_MODAL = "INTERGAMMA_MACHINE_RESTART_REDLIKE_MODAL";
export const INTERGAMMA_MACHINE_REBOOT_PC_MODAL = "INTERGAMMA_MACHINE_REBOOT_PC_MODAL";
export const INTERGAMA_DATE_PICKER_MODAL = "INTERGAMA_DATE_PICKER_MODAL";
export const INTERGAMMA_ADDITIONAL_PRINT_MODAL = "INTERGAMMA_ADDITIONAL_PRINT_MODAL";
export const MODIFIED_ORDER_MODAL = "MODIFIED_ORDER_MODAL";

export const ORDER_DATABASE_AVAILABLE_OK = 0;
export const ORDER_DATABASE_AVAILABLE_UNKNOWN_STATE = 1;
export const ORDER_DATABASE_AVAILABLE_UNKNOWN_BRAND = 2;
export const ORDER_DATABASE_AVAILABLE_LOGIN_FAILED = 3;

export const APPLICATION_STATUS_RUNNING = "RUNNING";
export const APPLICATION_STATUS_RESTORING = "RESTORING";
export const APPLICATION_STATUS_CLOSING = "CLOSING";

export const SETTINGS_MAIN_MENU = "main_menu";
export const SETTINGS_LEFT_MENU = "left_menu";
export const SETTINGS_SUBMENU = "submenu";
export const SETTINGS_OPTION = "option";

export const SEARCH_PANEL_DEFAULT = "SEARCH_PANEL_DEFAULT";
export const SEARCH_PANEL_COLOR_PALETTE = "SEARCH_PANEL_COLOR_PALETTE";
export const SEARCH_PANEL_COLOR_SEARCH = "SEARCH_PANEL_COLOR_SEARCH";

export const SEARCH_PANEL_PRODUCT = "product";
export const SEARCH_PANEL_FANDECK = "fandeck";
export const SEARCH_PANEL_FORMULA = "formula";
export const SEARCH_PANEL_FORMULA_NAME = "formula_name";
export const SEARCH_PANEL_FORMULA_CODE = "formula_code";
export const SEARCH_PANEL_BASE = "base";
export const SEARCH_PANEL_BIPP = "base_in_product_package";

export const ICON_DISPENSE = "ICON_DISPENSE";
export const ICON_EXTERIOR = "ICON_EXTERIOR";
export const ICON_INTERIOR = "ICON_INTERIOR";
export const ICON_INVALID = "ICON_INVALID";
export const ICON_LOADER = "ICON_LOADER";
export const ICON_MACHINE = "ICON_MACHINE";
export const ICON_MACHINE_DISPENSING = "ICON_MACHINE_DISPENSING";
export const ICON_PRINT = "ICON_PRINT";
export const ICON_SOLVENT = "ICON_SOLVENT";
export const ICON_UNIVERSAL = "ICON_UNIVERSAL";
export const ICON_WATER = "ICON_WATER";

export const COL_DEFAULT_PURCHASE_PRICE = "col-default-purchase-price";
export const COL_PURCHASE_PRICE = "col-purchase-price";
export const COL_DEFAULT_SELL_PRICE = "col-default-sell-price";
export const COL_SELL_PRICE = "col-sell-price";
export const COL_DEFAULT_VAT = "col-default-vat";
export const COL_VAT = "col-vat";
export const COL_DEFAULT_SURCHARGE = "col-default-surcharge";
export const COL_SURCHARGE = "col-surcharge";
export const COL_DEFAULT_PRICE_GROUP_PRICE = "col-default-price-group-price";
export const COL_PRICE_GROUP_PRICE = "col-price-group-price";
export const COL_MARGIN = "col-margin";
export const COL_POS_COEFICIENT = "col-pos-coeficient";
